<template>
  <v-card>
    <v-toolbar card color="white">
      <team-filters :entity-id="entityId" @search="localPagination.page = 1" />
      <v-text-field
        v-model="localFilters.match"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
        @keyup.enter="$store.dispatch('teams/fetchList')"
      />
      <meta-button
        v-if="edit && can('create', 'team')"
        type="new"
        @click="$emit('form')"
      />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formatedList"
        :loading="loading"
        :rows-per-page-items="[10, 25, 50]"
        disable-initial-sort
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <!--     :total-items="localPagination.totalItems"
          :pagination.sync="localPagination"-->
        <template slot="items" slot-scope="props">
          <td v-if="edit" class="text-xs-center px-0">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon
                  v-if="can('edit', 'team', props.item)"
                  color="success"
                  class="mr-1"
                  @click="sendNotification(props.item._id)"
                  v-on="on"
                >
                  mail
                </v-icon>
              </template>
              <span>{{ $t('action.buttons.sendNotification') }}</span>
            </v-tooltip>
            <v-icon
              v-if="can('edit', 'team', props.item)"
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="can('delete', 'team', props.item)"
              color="error"
              @click="ifDelete(props.item._id)"
            >
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td class="text-xs-center">
            <v-avatar size="32">
              <img :src="props.item.logo" alt />
            </v-avatar>
          </td>

          <td style="min-width: 350px">
            {{ props.item.name }}
          </td>
          <td class="text-xs-center" style="min-width: 350px">
            <template v-for="(category, index) in props.item.categoryName">
              <v-chip :key="index + category" small color="primary" dark>
                {{ category }}
              </v-chip>
            </template>
          </td>
          <template v-if="!entityId">
            <td style="min-width: 300px">
              {{ props.item.entityName }}
            </td>
            <td class="text-xs-center">
              {{ props.item.createdAt }}
            </td>
            <td style="min-width: 150px">
              {{ props.item.createdBy }}
            </td>
            <td class="text-xs-center">
              <i
                class="icon material-icons cursor"
                @click="openUpdated(props.item._id)"
                >visibility</i
              >
            </td>
          </template>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
    <dialog-notification-form
      v-if="dialogNotification"
      :team-id="teamId"
      :dialog="true"
      @close="dialogNotification = false"
    />
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TeamFilters from './TeamFilters'
import DialogNotificationForm from '@/components/apps/notifications/FormManager'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'
// import { debounce } from 'debounce'

export default {
  name: 'TeamList',
  components: {
    DialogDelete,
    DialogUpdatedRecord,
    TeamFilters,
    DialogNotificationForm,
  },
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
    entityId: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
      dialogNotification: false,
      teamId: '',
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function () {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('teams')
      },
    },
    'localPagination.page': {
      handler: function () {
        this.debounceFetch('teams')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function () {
        this.debounceFetch('teams')
      },
    },
    'localPagination.sortBy': {
      handler: function () {
        this.debounceFetch('teams')
      },
    },
    'localPagination.descending': {
      handler: function () {
        this.debounceFetch('teams')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.teams.loading,
      selected: (state) => state.teams.selected,
      pagination: (state) => state.teams.pagination,
      filters: (state) => state.teams.filters,
    }),
    ...mapGetters({
      formatedList: 'teams/formatedList',
    }),
    headers() {
      let headers = []
      if (this.edit) {
        headers.push({
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        })
      }
      headers = headers.concat([
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.global.logo'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$tc('models.category'),
          align: 'center',
          sortable: false,
        },
      ])
      if (!this.entityId) {
        headers = headers.concat([
          {
            text: this.$tc('models.entity'),
          },
          {
            text: this.$t('fields.global.createdAt'),
            align: 'center',
            value: 'createdAt',
          },
          {
            text: this.$t('fields.global.createdBy'),
            value: 'createdBy',
          },
          {
            text: this.$t('titles.global.updates'),
            align: 'center',
            sortable: false,
          },
        ])
      }

      return headers
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('teams/setPagination', value)
      },
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('teams/setFilters', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'teams/fetchOne',
      setDelete: 'teams/delete',
      reset: 'teams/reset',
      fetchList: 'teams/fetchList',
    }),
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => this.$emit('form'))
    },
    openUpdated(id) {
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    sendNotification(item) {
      this.teamId = item
      this.dialogNotification = true
    },
    // debounceFetch: debounce(function () {
    //   let params = { match: this.search }
    //   if (this.entityId) params.entityId = this.entityId
    //   this.fetchList(params)
    // }, 1000)
  },
}
</script>
